// Only GtmFilterClickType matches these (GA4); no Marketing or Data Cloud
export const PLATFORM_FILTER_ENGAGEMENT_ELEMENT_TYPE = 'platformFilterEngagement';
export const SEARCH_TYPE_SWITCH_ENGAGEMENT_ELEMENT_TYPE = 'searchTypeSwitchEngagement';
